'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.performDeposit = performDeposit;
exports.onPerformDepositSucceded = onPerformDepositSucceded;
exports.onPerformDepositFailed = onPerformDepositFailed;
exports.onPerformOpenStandardDeposit = onPerformOpenStandardDeposit;
exports.watchPerformDeposit = watchPerformDeposit;
exports.watchPerformDepositSucceded = watchPerformDepositSucceded;
exports.watchPerformApayDepositSucceded = watchPerformApayDepositSucceded;
exports.watchPerformDepositFailed = watchPerformDepositFailed;
exports.watchPerformOpenStandardDeposit = watchPerformOpenStandardDeposit;

var _messageBus = require('@wh/message-bus');

var _effects = require('redux-saga/effects');

var _reduxSaga = require('redux-saga');

var _quickDepositLogic = require('@wh/quick-deposit-logic');

var _init3DSDepositSaga = require('./init3DSDepositSaga');

var _actions = require('../../actions');

var _selectors = require('../../selectors');

var _events = require('../../events');

var _analytics = require('../../analytics');

var _constants = require('../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(performDeposit),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(onPerformDepositSucceded),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(onPerformDepositFailed),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(onPerformOpenStandardDeposit),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(watchPerformDeposit),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(watchPerformDepositSucceded),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(watchPerformApayDepositSucceded),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(watchPerformDepositFailed),
    _marked9 = /*#__PURE__*/_regenerator2.default.mark(watchPerformOpenStandardDeposit); /*eslint complexity: ["error", 20]*/

//compatibility to versions up to 0.15 of redux-sage


var takeEveryEffect = _effects.takeEvery || _reduxSaga.takeEvery;

/**
 * Performs a deposit
 * @returns {void}
 */
function performDeposit(_ref) {
  var depositData = _ref.depositData;
  var trackingData, initData, triggerApplePay, depositDataObj, needConsent, pmtApi, applePayMethod, depositResult;
  return _regenerator2.default.wrap(function performDeposit$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_selectors.trackingDataSelector);

        case 2:
          trackingData = _context.sent;
          _context.next = 5;
          return (0, _effects.select)(_selectors.initDataSelector);

        case 5:
          initData = _context.sent;
          _context.next = 8;
          return (0, _effects.select)(_selectors.getIsApplePayAvailable);

        case 8:
          triggerApplePay = _context.sent;
          depositDataObj = depositData.toJS();
          _context.prev = 10;

          if (!triggerApplePay) {
            _context.next = 15;
            break;
          }

          _context.t0 = null;
          _context.next = 18;
          break;

        case 15:
          _context.next = 17;
          return (0, _effects.select)(_selectors.activeCardNeedConsentSelector);

        case 17:
          _context.t0 = _context.sent;

        case 18:
          needConsent = _context.t0;
          pmtApi = new _quickDepositLogic.PaymentsApi();
          applePayMethod = triggerApplePay ? pmtApi.obPmtApiInstance.paymentMethods && pmtApi.obPmtApiInstance.paymentMethods.registeredMethods[0] : null;
          _context.next = 23;
          return (0, _effects.call)(function () {
            return applePayMethod ? pmtApi.performApayDeposit(depositDataObj.amount, initData.pmtSource) : pmtApi.performCreditCardDeposit(depositDataObj.cardId, depositDataObj.amount, depositDataObj.cvv, depositDataObj.expiryDate, initData.pmtSource, needConsent);
          });

        case 23:
          depositResult = _context.sent;

          if (!(depositResult.status === _constants.OB_PMT_API_STATUS_AWAITING3DS || depositResult.status === _constants.OB_PMT_API_STATUS_AWAITING3DS_V2)) {
            _context.next = 28;
            break;
          }

          return _context.delegateYield((0, _init3DSDepositSaga.performInit3DS)(applePayMethod ? applePayMethod : depositDataObj, depositResult), 't1', 26);

        case 26:
          _context.next = 47;
          break;

        case 28:
          if (!(depositResult.status === _constants.OB_PMT_API_STATUS_SUCCESS)) {
            _context.next = 43;
            break;
          }

          if (!triggerApplePay) {
            _context.next = 34;
            break;
          }

          _context.next = 32;
          return (0, _effects.put)((0, _actions.performApayDepositSucceded)(depositResult));

        case 32:
          _context.next = 36;
          break;

        case 34:
          _context.next = 36;
          return (0, _effects.put)((0, _actions.performDepositSucceded)(depositResult));

        case 36:
          _context.next = 38;
          return (0, _effects.put)((0, _actions.trackEvent)(_analytics.MESSAGE_TRACKING_QD_SUCCESSFUL, {
            EffortAttempt: trackingData.submitCount.toString(),
            DepositAmount: depositDataObj.amount
          }));

        case 38:
          if (!initData.closeOnSuccess) {
            _context.next = 41;
            break;
          }

          _context.next = 41;
          return (0, _effects.put)((0, _actions.closingComponent)());

        case 41:
          _context.next = 47;
          break;

        case 43:
          _context.next = 45;
          return (0, _effects.put)((0, _actions.performDepositFailed)());

        case 45:
          _context.next = 47;
          return (0, _effects.put)((0, _actions.trackEvent)(_analytics.MESSAGE_TRACKING_QD_UNSUCCESSFUL, {
            EffortAttempt: trackingData.submitCount.toString(),
            DepositAmount: depositDataObj.amount,
            ErrorFields: _analytics.GENERIC_ERROR_FIELD_IDENTIFIER,
            ErrorFieldsAmount: '1',
            ErrorMessages: depositResult.status,
            ErrorCode: depositResult.status
          }));

        case 47:
          _context.next = 55;
          break;

        case 49:
          _context.prev = 49;
          _context.t2 = _context['catch'](10);
          _context.next = 53;
          return (0, _effects.put)((0, _actions.performDepositFailed)(_context.t2));

        case 53:
          _context.next = 55;
          return (0, _effects.put)((0, _actions.trackEvent)(_analytics.MESSAGE_TRACKING_QD_UNSUCCESSFUL, {
            EffortAttempt: trackingData.submitCount.toString(),
            ErrorFields: _analytics.GENERIC_ERROR_FIELD_IDENTIFIER,
            ErrorFieldsAmount: '1',
            ErrorMessages: _context.t2.message,
            ErrorCode: _context.t2.code || null,
            DepositAmount: depositDataObj.amount
          }));

        case 55:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[10, 49]]);
}

/**
 * Fetch onPerformDepositSucceded Saga
 * @returns {void}
 */
function onPerformDepositSucceded(_ref2) {
  var result = _ref2.result;
  return _regenerator2.default.wrap(function onPerformDepositSucceded$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _messageBus.publish)(_events.MESSAGE_PUB_QD_SUCCESS, result);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

/**
 * Fetch onPerformDepositFailed Saga
 * @returns {void}
 */
function onPerformDepositFailed(_ref3) {
  var error = _ref3.error;
  return _regenerator2.default.wrap(function onPerformDepositFailed$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _messageBus.publish)(_events.MESSAGE_PUB_QD_FAIL, error);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

/**
 * Fetch onPerformOpenStandardDeposit Saga
 * @returns {void}
 */
function onPerformOpenStandardDeposit() {
  return _regenerator2.default.wrap(function onPerformOpenStandardDeposit$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.put)((0, _actions.closingComponent)(true));

        case 2:
          _context4.next = 4;
          return (0, _messageBus.publish)(_events.MESSAGE_PUB_QD_OPEN_DEPOSIT, {});

        case 4:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

/**
 * Fetch watchPerformDeposit Saga
 * @returns {void}
 */
function watchPerformDeposit() {
  return _regenerator2.default.wrap(function watchPerformDeposit$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return takeEveryEffect(_constants.QD_ACTION_PERFORM_DEPOSIT, performDeposit);

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

/**
 * Fetch watchPerformDepositSucceded Saga
 * @returns {void}
 */
function watchPerformDepositSucceded() {
  return _regenerator2.default.wrap(function watchPerformDepositSucceded$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return takeEveryEffect(_constants.QD_ACTION_PERFORM_DEPOSIT_SUCCEDED, onPerformDepositSucceded);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

/**
 * Fetch watchPerformApayDepositSucceded Saga
 * @returns {void}
 */
function watchPerformApayDepositSucceded() {
  return _regenerator2.default.wrap(function watchPerformApayDepositSucceded$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return takeEveryEffect(_constants.QD_ACTION_PERFORM_APAY_DEPOSIT_SUCCEDED, onPerformDepositSucceded);

        case 2:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}

/**
 * Fetch watchPerformDepositFailed Saga
 * @returns {void}
 */
function watchPerformDepositFailed() {
  return _regenerator2.default.wrap(function watchPerformDepositFailed$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return takeEveryEffect(_constants.QD_ACTION_PERFORM_DEPOSIT_FAILED, onPerformDepositFailed);

        case 2:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

/**
 * Fetch watchPerformOpenStandardDeposit Saga
 * @returns {void}
 */
function watchPerformOpenStandardDeposit() {
  return _regenerator2.default.wrap(function watchPerformOpenStandardDeposit$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return takeEveryEffect(_constants.QD_ACTION_OPEN_STANDARD_DEPOSIT, onPerformOpenStandardDeposit);

        case 2:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}